import { styled } from '@mui/system';
import { mainTheme } from '../../theme/mainTheme';

export const HorizontalLine = styled('div')({
    width: '100%',
    borderBottom: `2px solid ${mainTheme.palette.text.secondary}`,
    marginTop: '8px',
});